import { array, bool, func, object, string } from 'prop-types';
import React from 'react';

import { isStyledComponent } from 'ravenjs/utils/component';
import Typography from 'ravenjs/lib/Typography';
import { callFunc } from 'ravenjs/utils/actions';

import {
    MobileBreadcrumbWrapper,
    MobileStepHeader,
    MobileStepIndicator,
    MobileStepLabel,
    MobileStepStyled,
    StepHeader,
    StepIndicator,
    StepLabel,
    StepStyled,
} from './WizardBreadcrumbsStyled';

const WizardBreadcrumbs = ({
    currentStepName,
    CustomIndicator,
    onChangeStep,
    steps,
    statusByStep,
    isMobile,
}) => {
    if (isMobile) {
        return (
            <MobileBreadcrumbWrapper>
                {steps.map((step, idx) => {
                    const status = statusByStep[step] ? statusByStep[step] : '';
                    const stepId = idx === steps.length - 1 ? 'lastStep' : idx;

                    return (
                        <MobileStepStyled
                            key={stepId}
                            onClick={() => {
                                callFunc(onChangeStep, step);
                            }}
                        >
                            <MobileStepHeader>
                                <MobileStepLabel type={status}>
                                    <Typography type="wizardTitles" noGutter fontWeight="500">
                                        {step}
                                    </Typography>
                                </MobileStepLabel>
                                <MobileStepIndicator type={status} />
                            </MobileStepHeader>
                        </MobileStepStyled>
                    );
                })}
            </MobileBreadcrumbWrapper>
        );
    }

    return steps.map((step, idx) => {
        const status = statusByStep[step] ? statusByStep[step] : '';
        const stepId = idx === steps.length - 1 ? 'lastStep' : idx;
        const fontWeight = step === currentStepName ? 'bold' : '300';
        const Indicator = isStyledComponent(CustomIndicator) ? CustomIndicator : StepIndicator;

        return (
            <StepStyled
                id={stepId}
                key={stepId}
                onClick={() => {
                    callFunc(onChangeStep, step);
                }}
            >
                <StepHeader>
                    <Indicator type={status} />
                    <StepLabel>
                        <Typography
                            fontFamily="RobotoMono"
                            type="span"
                            noGutter
                            fontWeight={fontWeight}
                        >
                            {step}
                        </Typography>
                    </StepLabel>
                </StepHeader>
            </StepStyled>
        );
    });
};

WizardBreadcrumbs.propTypes = {
    CustomIndicator: object,
    onChangeStep: func,
    isMobile: bool,
    currentStepName: string,
    steps: array,
    statusByStep: array,
};

WizardBreadcrumbs.defaultProps = {
    CustomIndicator: null,
    currentStepName: '',
    isMobile: false,
    onChangeStep: null,
    steps: [],
    statusByStep: [],
};

export default WizardBreadcrumbs;
